/**
 * Telepro portal — dedicated axios with a separate token storage key
 * (`mc68_telepro_token`) so it does NOT collide with the business/admin
 * `mc68_token`. Same JWT_SECRET but different `kind` claim on the backend.
 */
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const TELEPRO_TOKEN_KEY = "mc68_telepro_token";

export const teleproApi = axios.create({
  baseURL: `${BASE}/api/telepro`,
  timeout: 30000,
});

teleproApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TELEPRO_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

teleproApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(TELEPRO_TOKEN_KEY);
    }
    return Promise.reject(err);
  }
);

export function teleproLogout() {
  localStorage.removeItem(TELEPRO_TOKEN_KEY);
}
